import React, { useState,useEffect } from 'react';
import { Form, Button, Modal, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
// import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import apiConfig from "../credentials/apiConfig";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import IconRepeat from '../../images/icon-repeat.png';
import IconChange from '../../images/icon-change.png';
import IconCancel from '../../images/icon-cancel.png';
import IconLock from '../../images/icon-lock.png';

const SubscriptionSecurityTab = ({ user }) => {
    const [cancelAt, setCancelAt] = useState(null);
    const [autoRenewal, setAutoRenewal] = useState(user?.isAutoRenewal || false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    // const navigate = useNavigate();

    const latestSubscription = user?.subscriptionHistory?.[0];
    const subscriptionName = latestSubscription?.subscriptionName || "No active plan";
    const amountPaid = latestSubscription?.amountPaid || 0;
    const billing = "Monthly"; // Optionally parse from other data if available


    const validationSchema = Yup.object({
        currentPassword: Yup.string().required("Current password is required"),
        password: Yup.string()
            .required("Password is required")
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~])[^"]{8,}$/,
                "Password should contain at least one uppercase, one lowercase, one number, one special character, and must not contain spaces"
            ),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("password"), null], "Passwords must match")
            .required("Confirm Password is required"),
    });

    const formik = useFormik({
        validateOnChange: true,
        validateOnBlur: true,
        initialValues: {
            email: "dummyuser@email.com",
            currentPassword: "",
            password: "",
            confirmPassword: "",
        },
        validationSchema,
        onSubmit: async (values) => {
            const userId = localStorage.getItem("userId");
            try {
                  const authToken = localStorage.getItem("authToken");
                setLoading(true);
                const response = await axios.post(
                    `${apiConfig.apiBaseURL}/changePassword`,
                    {

                        id: userId,
                        currentPassword: values.currentPassword,
                        newPassword: values.password,
                        confirmPassword: values.confirmPassword,
                    },
                    {
                        headers: {
                            "x-api-key": apiConfig["x-api-key"],
                            "Content-Type": "application/json",
                             "Authorization": `Bearer ${authToken}`
                        }
                    }
                );
                if (response.status === 200) {
                    console.log("Password changed successfully for:", values.email);
                    localStorage?.removeItem("tempmail");
                    toast.success("Password set successfully", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    // navigate("/");
                      formik.resetForm();
                    setShowPasswordModal(false);
                }
            } catch (error) {
                const message = error?.response?.data?.message || "Password setting failed";
                toast.error(message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } finally {
                setLoading(false);
            }
        },
    });

    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

    const currentPlan = {
        name: 'Professional Plan',
        price: 399.00,
        billing: 'Monthly'
    };

    useEffect(() => {
  if (user?.isAutoRenewal !== undefined) {
    setAutoRenewal(user.isAutoRenewal);
  }
}, [user?.isAutoRenewal]);


    const handleAutoRenewalToggle = () => {
        const newValue = !autoRenewal;

        Swal.fire({
            title: newValue ? 'Enable Auto Renewal?' : 'Disable Auto Renewal?',
            text: newValue
                ? 'Your subscription will automatically renew at the end of each billing period.'
                : 'Your subscription will no longer renew automatically at the end of the billing period.',
            icon: 'warning',
            showCancelButton: true,
            allowOutsideClick: false,
            showCloseButton: true,
            confirmButtonText: newValue ? 'Enable' : 'Disable',
            customClass: {
                container: "custom-swal-block",
                popup: "custom-swal-popup",
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const authToken = localStorage.getItem("authToken");
                    const response = await axios.post(
                        `${apiConfig.apiBaseURL}/toggleAutoRenewal`,
                        { cancel: !newValue },
                        {
                            headers: {
                                "x-api-key": apiConfig["x-api-key"],
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${authToken}`
                            }
                        }
                    );

                    if (response.data.success) {
                        setAutoRenewal(newValue);
                        toast.success(response.data.message || "Auto renewal updated.", {
                            toastId: "auto-renewal-updated"
                        });
                    } else {
                        toast.error(response.data.message || "Failed to update auto-renewal.", {
                            toastId: "auto-renewal-error"
                        });
                    }
                } catch (error) {
                    console.error("Toggle auto-renewal error:", error);
                    toast.error("An error occurred while updating auto-renewal.");
                }
            }
        });
    };

    const handleCancelSubscription = async () => {
        setShowCancelModal(false);
        try {
            const authToken = localStorage.getItem("authToken");
            const response = await axios.post(
                `${apiConfig.apiBaseURL}/cancelSubscription`,
                {},
                {
                    headers: {
                        "x-api-key": apiConfig["x-api-key"],
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${authToken}`
                    }
                }
            );

            if (response.data.success) {
                toast.info(response.data.message || 'Subscription has been canceled.');
                setAutoRenewal(false);
                setCancelAt(response.data.cancelAt);
            } else {
                toast.error(response.data.message || 'Failed to cancel subscription.');
            }
        } catch (error) {
            console.error("Cancel subscription error:", error);
            toast.error("An error occurred while cancelling the subscription.");
        }
    };

    const handleClosePasswordModal = () => {
    setShowPasswordModal(false);
    formik.resetForm();
};


    return (
        <>
            <div className="mb-5">
                <h3 className="mb-3 fw-bold" style={{ fontSize: '20px' }}>Subscription</h3>


                <div className="d-flex justify-content-between align-items-center border py-4 px-2 border-bottom-0">
                    <div className="d-flex align-items-center px-2">

                        <div className='d-flex'>
                            <img src={IconRepeat} alt="auto" className='me-3 my-auto' width={35} height={31.5} />
                            <div>
                                <h5 className="mb-1 fw-bold text-primary" style={{ fontSize: '16px' }}>Auto Renewal</h5>
                                <p className="mb-0 text-light" style={{ fontSize: '14px' }}>Seamless Subscription Continuity</p>
                            </div>
                        </div>
                    </div>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-auto-renewal">
                                Manage your subscription's auto-renewal
                            </Tooltip>
                        }
                    >
                        <Form.Check
                            type="switch"
                            id="auto-renewal-switch"
                            checked={autoRenewal}
                            onChange={handleAutoRenewalToggle}
                            className='me-5 cursor-pointer'
                        />
                    </OverlayTrigger>

                </div>


                {/* <div className="d-flex justify-content-between align-items-center border  py-4 px-2 border-bottom-0">
                    <div className="d-flex align-items-center">
                        <div className="me-3">
                            <i className="bi bi-file-text fs-4"></i>
                        </div>
                        <div className='d-flex'>
                            <img src={IconChange} alt="auto" className='me-3 my-auto' width={32} height={33.5} />
                            <div>
                                <h5 className="mb-1 fw-bold text-primary" style={{ fontSize: '16px' }}>Change Plan</h5>
                                <p className="mb-0 text-light" style={{ fontSize: '14px' }}> {subscriptionName}</p>
                            </div>
                        </div>
                    </div>
                    <div className="text-end me-5">
                        <div className="fw-bold text-primary" style={{ fontSize: '16px' }}>{amountPaid.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</div>
                        <div className="mb-0 text-light" style={{ fontSize: '14px' }}>{currentPlan.billing}</div>
                    </div>
                </div> */}

                {cancelAt ? (
                    <div className="d-flex justify-content-between align-items-center border py-4 px-2">
                        <div className="d-flex align-items-center text-danger">
                            <div className="me-3">
                                <i className="bi bi-x-circle fs-4"></i>
                            </div>
                            <div className='d-flex'>
                                <img src={IconCancel} alt="cancelled" className='me-3' width={35} height={35} />
                                <h5 className="fw-bold text-dark my-auto" style={{ fontSize: '16px' }}>
                                    Subscription has been cancelled and will end at the end of the current billing period.
                                </h5>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="d-flex justify-content-between align-items-center border py-4 px-2">
                        <div className="d-flex align-items-center text-danger">
                            <div className="me-3">
                                <i className="bi bi-x-circle fs-4"></i>
                            </div>
                            <div className='d-flex'>
                                <img src={IconCancel} alt="auto" className='me-3' width={35} height={35} />
                                <h5 className="fw-bold text-primary my-auto" style={{ fontSize: '16px', cursor: 'pointer' }}
                                    onClick={() => setShowCancelModal(true)}>
                                    Cancel Subscription
                                </h5>
                            </div>
                        </div>
                    </div>
                )}

            </div>

            <div>
                <h3 className="mb-3 fw-bold" style={{ fontSize: '20px' }}>Security</h3>

                <div className="d-flex justify-content-between align-items-center border p-3 rounded">
                    <div className="d-flex align-items-center">
                        <div className="me-3">
                            <i className="bi bi-lock fs-4"></i>
                        </div>
                        <div className='d-flex'>
                            <img src={IconLock} alt="auto" className='me-3 my-auto' width={33} height={33} />
                            <h5 className=" fw-bold text-primary my-auto" style={{ fontSize: '16px', cursor: 'pointer' }}>Change Password</h5>
                        </div>
                    </div>
                    <Button variant="outline-primary" onClick={() => setShowPasswordModal(true)}>Change</Button>
                </div>
            </div>

            <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)} centered backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title className='fw-bold'>Cancel Subscription</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className='text-light'>
                        Are you sure you want to cancel your subscription?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" className='px-4' onClick={() => setShowCancelModal(false)}>
                        No
                    </Button>
                    <Button variant="primary" className='px-4' onClick={handleCancelSubscription}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showPasswordModal} onHide={handleClosePasswordModal} centered backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Change Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Card className="border-0 credential-page px-0 px-md-5">
                        <Form onSubmit={formik.handleSubmit}>
                            <Form.Group className="mb-4 position-relative" controlId="formCurrentPassword">
                                <Form.Label className="mb-1">Enter Old Password*</Form.Label>
                                <Form.Control
                                    type={showCurrentPassword ? "text" : "password"}
                                    name="currentPassword"
                                    placeholder="Current Password"
                                    className="p-3"
                                    value={formik.values.currentPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    isInvalid={formik.touched.currentPassword && formik.errors.currentPassword}
                                />
                                <i onClick={() => setShowCurrentPassword(!showCurrentPassword)} className="password-icon" style={{ position: "absolute", right: "31px", top: "43px", cursor: "pointer" }}>
                                    {showCurrentPassword ? <BsEyeSlash /> : <BsEye />}
                                </i>
                                <Form.Control.Feedback type="invalid">{formik.errors.currentPassword}</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-4 position-relative" controlId="formBasicPassword">
                                <Form.Label className="mb-1">Create New Password*</Form.Label>
                                <Form.Control
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="New Password"
                                    className="p-3 password"
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                    isInvalid={formik.errors.password}
                                />
                                <i onClick={togglePasswordVisibility} className="password-icon" style={{ position: "absolute", right: "31px", top: "43px", cursor: "pointer" }}>
                                    {showPassword ? <BsEyeSlash /> : <BsEye />}
                                </i>
                                <Form.Control.Feedback type="invalid">{formik.errors.password}</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3 position-relative" controlId="formBasicConfirmPassword">
                                <Form.Label className="mb-1">Confirm New Password*</Form.Label>
                                <Form.Control
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="confirmPassword"
                                    placeholder="Confirm Password"
                                    className="p-3 password"
                                    value={formik.values.confirmPassword}
                                    onChange={formik.handleChange}
                                    isInvalid={formik.errors.confirmPassword}
                                />
                                <i onClick={toggleConfirmPasswordVisibility} className="password-icon" style={{ position: "absolute", right: "31px", top: "43px", cursor: "pointer" }}>
                                    {showConfirmPassword ? <BsEyeSlash /> : <BsEye />}
                                </i>
                                <Form.Control.Feedback type="invalid">{formik.errors.confirmPassword}</Form.Control.Feedback>
                            </Form.Group>

                            <div className="d-flex justify-content-end">
                                <Button
                                   variant="primary"
                                   className="mt-1 border-0 text-white font-16 px-5 py-3 w-100 d-flex justify-content-center align-items-center"
                                   type="submit"
                                   disabled={loading}
                                >
                                {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                  Changing...
                              </>
                                ) : (
                                "Change Password"
                                    )}
                               </Button>

                            </div>

                            <p className='text-dark my-1'>Note:</p>
                            <ul className='text-light font-14 p-0' style={{ listStyle: 'none' }}>
                                <li>Minimum length: 8 characters</li>
                                <li>Include at least one uppercase letter, one lowercase letter, one number, and one special character (!, @, #, etc.)</li>
                                <li>Avoid common words, phrases, or predictable patterns</li>
                            </ul>

                        </Form>
                    </Card>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default SubscriptionSecurityTab;
